import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Paging {
  page: number;
  perPage: number;
  pageCount: number;
  totalCount: number;
}

export interface User {
  id: string;
  email: string;
  phone: string;
  role: string;
  createdDate: string;
  firstname: string;
  middlename: string;
  lastname: string;
  title: string;
  signature: string;
  address: string;
}

export interface UsersResponse {
  status: string;
  message: string;
  paging: Paging;
  data: Array<User>;
}

export interface AdminInfo {
  users: UsersResponse;
  userEdit: User;
  message: string;
}

@Module
export default class AdminModule extends VuexModule implements AdminInfo {
  users = {} as UsersResponse;
  userEdit = {} as User;
  message = "";
  pendingUsers = {} as UsersResponse;

  get currentUsers(): UsersResponse {
    return this.users;
  }

  get currentUserEdit(): User {
    return this.userEdit;
  }

  get getAdminMessage(): string {
    return this.message;
  }

  get currentPendingUsers(): UsersResponse {
    return this.pendingUsers;
  }

  @Mutation
  [Mutations.SET_ADMIN_MESSAGE](message) {
    this.message = message;
  }

  @Mutation
  [Mutations.SET_USERS](users) {
    this.users = users;
  }

  @Mutation
  [Mutations.SET_ADMIN_USER_EDIT](userEdit) {
    this.userEdit = userEdit;
  }

  @Mutation
  [Mutations.SET_PENDING_USERS](pendingUsers) {
    this.pendingUsers = pendingUsers;
  }

  @Action
  [Actions.GET_USERS](params) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      ApiService.query("admin/users", params)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_USERS, data);
        })
        .catch(() => {
          this.context.commit(Mutations.SET_USERS, {});
        });
    } else {
      this.context.commit(Mutations.SET_USERS, {});
    }
  }

  @Action
  [Actions.ADMIN_ASSIGN_ROLE](data) {
    return new Promise<void>((resolve, reject) => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.post("admin/assignRole", data)
          .then(({ data }) => {
            console.log(data);
            this.context.commit(Mutations.SET_ADMIN_MESSAGE, data.message);
            resolve();
          })
          .catch(({ response }) => {
            console.log(response);
            this.context.commit(
              Mutations.SET_ADMIN_MESSAGE,
              response.data.message
            );
            reject();
          });
      } else {
        this.context.commit(Mutations.SET_ADMIN_MESSAGE, "Something wrong");
        reject();
      }
    });
  }

  @Action
  [Actions.ADMIN_REMOVE_ROLE](data) {
    return new Promise<void>((resolve, reject) => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.post("admin/removeRole", data)
          .then(({ data }) => {
            console.log(data);
            this.context.commit(Mutations.SET_ADMIN_MESSAGE, data.message);
            resolve();
          })
          .catch(({ response }) => {
            console.log(response);
            this.context.commit(
              Mutations.SET_ADMIN_MESSAGE,
              response.data.message
            );
            reject();
          });
      } else {
        this.context.commit(Mutations.SET_ADMIN_MESSAGE, "Something wrong");
        reject();
      }
    });
  }

  @Action
  [Actions.GET_PENDING_USERS](params) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      ApiService.query("admin/pendingUsers", params)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_PENDING_USERS, data);
        })
        .catch(() => {
          this.context.commit(Mutations.SET_PENDING_USERS, {});
        });
    } else {
      this.context.commit(Mutations.SET_PENDING_USERS, {});
    }
  }

  @Action
  [Actions.ADMIN_APPROVE_USER](data) {
    return new Promise<void>((resolve, reject) => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.post("admin/user/approve", data)
          .then(({ data }) => {
            console.log(data);
            this.context.commit(Mutations.SET_ADMIN_MESSAGE, data.message);
            resolve();
          })
          .catch(({ response }) => {
            console.log(response);
            this.context.commit(
              Mutations.SET_ADMIN_MESSAGE,
              response.data.message
            );
            reject();
          });
      } else {
        this.context.commit(Mutations.SET_ADMIN_MESSAGE, "Something wrong");
        reject();
      }
    });
  }
}
